import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import StageSelector from '../../../common/StageSelector';

export default class Header extends React.PureComponent {

    render() {
        return (
            <div id="controls">
                <div className="branding raven-logo">
                    <Link to="/"/>
                </div>
                <div className="viewOptions">
                    <div className="row spacedRow">
                        <div className="col-3" >
                            <StageSelector
                                ravenStages = {this.props.ravenStages}
                                stage = {this.props.stage}
                                onRavenStageChange = {this.props.onRavenStageChange}
                            />
                        </div>
                    </div>
                    
                </div>
            </div>
        );
    }
}


Header.propTypes = {
    ravenStages: PropTypes.array.isRequired,
    stage: PropTypes.string.isRequired,
    onRavenStageChange: PropTypes.func.isRequired,
};